import React from 'react';
import { gql, useMutation } from '@apollo/client';
import { captureApolloError } from 'util/apolloError';
import { PrimaryButton } from 'system/base/Button';
import { EditNoteMutation } from 'types/graphql';

export const EDIT_NOTE_MUTATION = gql`
  mutation EditNote($input: EditNoteInput!) {
    editNote(input: $input) {
      success
      errors {
        message
      }
    }
  }
`;

export type EditNoteControlProps = {
  id: string;
  content: string;
  onSuccess: () => void;
  onFailure: () => void;
};

export default function EditNoteButton({
  id,
  content,
  onSuccess,
  onFailure,
}: EditNoteControlProps): JSX.Element {
  const [performEditNote, { error }] = useMutation<EditNoteMutation>(
    EDIT_NOTE_MUTATION
  );
  if (error) captureApolloError(error);

  return (
    <PrimaryButton
      data-testid="save-edit-note"
      onClick={() => {
        performEditNote({
          variables: {
            input: {
              noteId: id,
              noteContent: content,
            },
          },
        })
          .then(onSuccess)
          .catch((e) => {
            MetaError.notify(e);
            onFailure();
          });
      }}
    >
      Save
    </PrimaryButton>
  );
}
